import { importFile } from '@controllers/Investors/EstateObjectsController'
import { router } from '@inertiajs/vue3'
import { ref } from 'vue'

export const ESTATE_OBJECT_IMPORT_ACCEPT =
  '.xlsx,.xls,.pdf,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export function useEstateObjectImport() {
  const uploading = ref(false)

  function upload(file: File | undefined): void {
    if (!file) {
      return
    }

    uploading.value = true

    router.post(
      importFile().url,
      { file },
      {
        forceFormData: true,
        preserveScroll: true,
        onFinish: () => (uploading.value = false),
      },
    )
  }

  return { uploading, upload }
}
